import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import '../App.css'; 
import './Rapports.css'; 
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {AddRapportsSpintoss} from '../Redux/Actions/RapportSpintossAction';
import { current } from "../Redux/Actions/AuthActions";

const RapportsSpintoss = () => {
  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(current())
  },[dispatch])

  const user = useSelector((state) => state.AuthReducer.user);
  
  const [emplacement, setEmplacement] = useState('');

  // 🔹 Définir l'emplacement par défaut basé sur la localisation de l'utilisateur
  useEffect(() => {
    if (user && !emplacement) {
      if (user.localisation) {
        setEmplacement(user.localisation);
      }
    }
  }, [user, emplacement]);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [especeCash, setEspeceCash] = useState(0);
  const [especeTpe, setEspeceTpe] = useState(0);
  const [reduction10Cash, setReduction10Cash] = useState(0);
  const [reduction10Tpe, setReduction10Tpe] = useState(0);
  const [reduction20Cash, setReduction20Cash] = useState(0);
  const [reduction20Tpe, setReduction20Tpe] = useState(0);
  const [reductionTwinCash, setReductionTwinCash] = useState(0);
  const [reductionTwinTpe, setReductionTwinTpe] = useState(0);
  const [privilegeCash, setPrivilegeCash] = useState(0);
  const [privilegeTpe, setPrivilegeTpe] = useState(0);
  const [glovoCash, setGlovoCash] = useState(0);
  const [glovoTpe, setGlovoTpe] = useState(0);
  const [trestoCash, setTrestoCash] = useState(0);
  const [trestoTpe, setTrestoTpe] = useState(0);
  const [tpeCash, setTpeCash] = useState(0);
  const [tpeTpe, setTpeTpe] = useState(0);
  const [chequeCash, setChequeCash] = useState(0);
  const [chequeTpe, setChequeTpe] = useState(0);
  const [packAnnifCash, setPackAnnifCash] = useState(0);
  const [packAnnifTpe, setPackAnnifTpe] = useState(0);

  const [taxiExpense, setTaxiExpense] = useState(0);
  const [repairExpense, setRepairExpense] = useState(0);
  const [advanceExpense, setAdvanceExpense] = useState(0);
  const [miscExpense, setMiscExpense] = useState(0);
  const [otherExpense, setOtherExpense] = useState(0);

  const [explanation, setExplanation] = useState('');
  const [showTpeModal, setShowTpeModal] = useState(false);

  const handleCloseTpeModal = () => setShowTpeModal(false);
  const handleShowTpeModal = () => setShowTpeModal(true);

  const navigate = useNavigate();

  const calculateTotalAmount = () => {
    return (
      parseFloat(especeCash || 0) + parseFloat(especeTpe || 0) +
      parseFloat(reduction10Cash || 0) + parseFloat(reduction10Tpe || 0) +
      parseFloat(reduction20Cash || 0) + parseFloat(reduction20Tpe || 0) +
      parseFloat(reductionTwinCash || 0) + parseFloat(reductionTwinTpe || 0) +
      parseFloat(privilegeCash || 0) + parseFloat(privilegeTpe || 0) +
      parseFloat(glovoCash || 0) + parseFloat(glovoTpe || 0) +
      parseFloat(trestoCash || 0) + parseFloat(trestoTpe || 0) +
      parseFloat(tpeCash || 0) + parseFloat(tpeTpe || 0) +
      parseFloat(chequeCash || 0) + parseFloat(chequeTpe || 0) +
      parseFloat(packAnnifCash || 0) + parseFloat(packAnnifTpe || 0)
    ).toFixed(3);
  };

  const calculateTotalTPE = () => {
    return (
      parseFloat(especeTpe || 0) +
      parseFloat(reduction10Tpe || 0) +
      parseFloat(reduction20Tpe || 0) +
      parseFloat(reductionTwinTpe || 0) +
      parseFloat(privilegeTpe || 0) +
      parseFloat(glovoTpe || 0) +
      parseFloat(trestoTpe || 0) +
      parseFloat(tpeTpe || 0) +
      parseFloat(chequeTpe || 0) +
      parseFloat(packAnnifTpe || 0)
    ).toFixed(3);
  };

  const calculateTotalExpenses = () => {
    return (
      parseFloat(taxiExpense || 0) +
      parseFloat(repairExpense || 0) +
      parseFloat(advanceExpense || 0) +
      parseFloat(miscExpense || 0) +
      parseFloat(otherExpense || 0)
    ).toFixed(3);
  };

  const handleNumberInput = (e, setState) => {
    const value = e.target.value;
    if (/^\d*\.?\d{0,3}$/.test(value)) {
      setState(value);
    }
  };

  const handleRapportSpintoss = (e) => {
    e.preventDefault();

    if (!emplacement || !date || !explanation) {
      alert("Veuillez remplir tous les champs correctement.");
      return;
    }

    const rapportData = {
      DateCollect : date.slice(0,10),
      localisation : emplacement,
      Espece: parseFloat(especeCash || 0) + parseFloat(especeTpe || 0),
      Reduction10: parseFloat(reduction10Cash || 0) + parseFloat(reduction10Tpe || 0),
      Reduction20: parseFloat(reduction20Cash || 0) + parseFloat(reduction20Tpe || 0),
      ReductionTwin: parseFloat(reductionTwinCash || 0) + parseFloat(reductionTwinTpe || 0),
      Privilege: parseFloat(privilegeCash || 0) + parseFloat(privilegeTpe || 0),
      Glovo: parseFloat(glovoCash || 0) + parseFloat(glovoTpe || 0),
      Tresto: parseFloat(trestoCash || 0) + parseFloat(trestoTpe || 0),
      Tpe: parseFloat(tpeCash || 0) + parseFloat(tpeTpe || 0),
      Cheque: parseFloat(chequeCash || 0) + parseFloat(chequeTpe || 0),
      PackAnnif: parseFloat(packAnnifCash || 0) + parseFloat(packAnnifTpe || 0),
      TotalAmount: parseFloat(calculateTotalAmount()), 
      TotalTpe: parseFloat(calculateTotalTPE()),
      DailyExpenses: parseFloat(calculateTotalExpenses()),
      TaxiExpenses: parseFloat(taxiExpense || 0),
      RepairExpenses: parseFloat(repairExpense || 0),
      StaffAdvance: parseFloat(advanceExpense || 0),
      MiscPurchases: parseFloat(miscExpense || 0),
      OtherExpenses: parseFloat(otherExpense || 0),
      feedback : explanation,
      owner : user._id
    };
    
    dispatch(AddRapportsSpintoss(rapportData,navigate))
  };

  return (
    <div className="list-rapports">

      <h3>Rapport Spintoss</h3>

    <Form className="rapport-form" onSubmit={handleRapportSpintoss}>
      <Row className="mb-3">
        <Form.Group as={Col} controlId="formGridState" className="rapport-form-group">
          <Form.Label>Emplacement</Form.Label>
          <Form.Select 
            onChange={(e) => setEmplacement(e.target.value)} 
            className="rapport-select" 
            value={emplacement || "Choisissez un emplacement..."}>
            <option disabled value="Choisissez un emplacement...">Choisissez un emplacement...</option>
            <option>Spintoss- Manar City</option>
            <option>Spintoss - Tunisia Mall</option>
            <option>Spintoss - Jardins d'eL Menzah</option>
            <option>Spintoss - Mall of Djerba</option>
          </Form.Select>
        </Form.Group>
          
        <Form.Group as={Col} controlId="formGridDate" className="rapport-form-group">
      <Form.Label>Date du jour</Form.Label>
      <Form.Control 
        type="date" 
        className="rapport-input" 
        value={date} 
        onChange={(e) => setDate(e.target.value)}
        readOnly={user?.role !== 'admin'} // Rend le champ modifiable uniquement pour l'admin
      />
    </Form.Group>
      </Row>

      <div className="section-header">
        <h4>Recettes (Espèces)</h4>
        <Button onClick={handleShowTpeModal} className="tpe-modal-btn">
          💳 Paiements TPE
        </Button>
      </div>

      <Row className="mb-4">
        <Form.Group as={Col} controlId="formEspece" className="rapport-form-group">
          <Form.Label>Espéces</Form.Label>
          <Form.Control 
            type="text" 
            value={especeCash}
            onChange={(e) =>  handleNumberInput(e, setEspeceCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formReduction10" className="rapport-form-group">
          <Form.Label>Reduction 10%</Form.Label>
          <Form.Control 
            type="text" 
            value={reduction10Cash}
            onChange={(e) =>  handleNumberInput(e, setReduction10Cash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formReduction20" className="rapport-form-group">
          <Form.Label>Réduction 20%</Form.Label>
          <Form.Control 
            type="text" 
            value={reduction20Cash}
            onChange={(e) =>  handleNumberInput(e, setReduction20Cash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      <Row className="mb-4">
        <Form.Group as={Col} controlId="formReductionTwin" className="rapport-form-group">
          <Form.Label>Réduction TwinClub</Form.Label>
          <Form.Control 
            type="text" 
            value={reductionTwinCash}
            onChange={(e) =>  handleNumberInput(e, setReductionTwinCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formGlovo" className="rapport-form-group">
          <Form.Label>Glovo</Form.Label>
          <Form.Control 
            type="text" 
            value={glovoCash}
            onChange={(e) =>  handleNumberInput(e, setGlovoCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      <Row className="mb-4">
        <Form.Group as={Col} controlId="formTresto" className="rapport-form-group">
          <Form.Label>Ticket Resto</Form.Label>
          <Form.Control 
            type="text" 
            value={trestoCash}
            onChange={(e) =>  handleNumberInput(e, setTrestoCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      
        <Form.Group as={Col} controlId="formTpe" className="rapport-form-group">
          <Form.Label>TPE</Form.Label>
          <Form.Control 
            type="text" 
            value={tpeCash}
            onChange={(e) =>  handleNumberInput(e, setTpeCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formCheque" className="rapport-form-group">
          <Form.Label>Chèque</Form.Label>
          <Form.Control 
            type="text" 
            value={chequeCash}
            onChange={(e) =>  handleNumberInput(e, setChequeCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      <Row className="mb-4">
      <Form.Group as={Col} controlId="formPrivilege" className="rapport-form-group">
          <Form.Label>Privilége</Form.Label>
          <Form.Control 
            type="text" 
            value={privilegeCash}
            onChange={(e) =>  handleNumberInput(e, setPrivilegeCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formPackAnnif" className="rapport-form-group">
          <Form.Label>Pack Anniversaire</Form.Label>
          <Form.Control 
            type="text" 
            value={packAnnifCash}
            onChange={(e) =>  handleNumberInput(e, setPackAnnifCash)}
            className="rapport-input" 
            placeholder="Espèces (DT)" 
          />
        </Form.Group>
      </Row>

      {/* Modal for TPE Payments */}
      <Modal show={showTpeModal} onHide={handleCloseTpeModal} size="lg" centered className="tpe-modal">
        <Modal.Header closeButton>
          <Modal.Title>Saisie des Paiements TPE</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-4">Saisissez les montants payés par TPE pour chaque rubrique.</p>
          <Row>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Espéces</Form.Label>
              <Form.Control type="text" value={especeTpe} onChange={(e) => handleNumberInput(e, setEspeceTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Reduction 10%</Form.Label>
              <Form.Control type="text" value={reduction10Tpe} onChange={(e) => handleNumberInput(e, setReduction10Tpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Réduction 20%</Form.Label>
              <Form.Control type="text" value={reduction20Tpe} onChange={(e) => handleNumberInput(e, setReduction20Tpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Réduction TwinClub</Form.Label>
              <Form.Control type="text" value={reductionTwinTpe} onChange={(e) => handleNumberInput(e, setReductionTwinTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Glovo</Form.Label>
              <Form.Control type="text" value={glovoTpe} onChange={(e) => handleNumberInput(e, setGlovoTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Ticket Resto</Form.Label>
              <Form.Control type="text" value={trestoTpe} onChange={(e) => handleNumberInput(e, setTrestoTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>TPE</Form.Label>
              <Form.Control type="text" value={tpeTpe} onChange={(e) => handleNumberInput(e, setTpeTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Chèque</Form.Label>
              <Form.Control type="text" value={chequeTpe} onChange={(e) => handleNumberInput(e, setChequeTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Privilége</Form.Label>
              <Form.Control type="text" value={privilegeTpe} onChange={(e) => handleNumberInput(e, setPrivilegeTpe)} placeholder="0.000 DT" />
            </Form.Group>
            <Form.Group as={Col} md={6} className="mb-3">
              <Form.Label>Pack Anniversaire</Form.Label>
              <Form.Control type="text" value={packAnnifTpe} onChange={(e) => handleNumberInput(e, setPackAnnifTpe)} placeholder="0.000 DT" />
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseTpeModal}>Confirmer</Button>
        </Modal.Footer>
      </Modal>

      <hr />
      <h5>Dépenses Détailées</h5>
      <Row>
        <Form.Group as={Col} controlId="formTaxiExpense" className="rapport-form-group">
          <Form.Label>Frais de Taxi</Form.Label>
          <Form.Control 
            type="text" 
            value={taxiExpense}
            onChange={(e) => handleNumberInput(e, setTaxiExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formRepairExpense" className="rapport-form-group">
          <Form.Label>Frais de Réparation</Form.Label>
          <Form.Control 
            type="text" 
            value={repairExpense}
            onChange={(e) => handleNumberInput(e, setRepairExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formAdvanceExpense" className="rapport-form-group">
          <Form.Label>Avance Personnel</Form.Label>
          <Form.Control 
            type="text" 
            value={advanceExpense}
            onChange={(e) => handleNumberInput(e, setAdvanceExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} controlId="formMiscExpense" className="rapport-form-group">
          <Form.Label>Achats Divers</Form.Label>
          <Form.Control 
            type="text" 
            value={miscExpense}
            onChange={(e) => handleNumberInput(e, setMiscExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>

        <Form.Group as={Col} controlId="formOtherExpense" className="rapport-form-group">
          <Form.Label>Autres</Form.Label>
          <Form.Control 
            type="text" 
            value={otherExpense}
            onChange={(e) => handleNumberInput(e, setOtherExpense)}
            className="rapport-input" 
            placeholder="0" 
          />
        </Form.Group>
        <Col></Col>
      </Row>

      <hr />
      <Row>
        <Form.Group as={Col} controlId="formGridAmount" className="rapport-form-group">
          <Form.Label>Montant Total</Form.Label>
          <Form.Control 
            value={calculateTotalAmount()}
            readOnly
            type="text" 
            className="rapport-input" 
          />
        </Form.Group>
      
        <Form.Group as={Col} controlId="formGridExpense" className="rapport-form-group">
          <Form.Label>Dépenses Total</Form.Label>
          <Form.Control 
            value={calculateTotalExpenses()}
            readOnly
            type="text" 
            className="rapport-input" 
          />
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} controlId="formGridDifference" className="rapport-form-group">
          <Form.Label>Différence (Total - Dépenses)</Form.Label>
          <Form.Control 
            value={(parseFloat(calculateTotalAmount()) - parseFloat(calculateTotalExpenses())).toFixed(3)}
            readOnly
            type="text" 
            className="rapport-input" 
            style={{ fontWeight: 'bold', color: 'blue' }}
          />
          <Form.Text className="text-muted">
            Dont TPE: {calculateTotalTPE()} TND
          </Form.Text>
        </Form.Group>
      </Row>

        <Form.Group as={Col} controlId="formExplanation" className="rapport-form-group">
          <Form.Label>Explication</Form.Label>
          <Form.Control 
            as="textarea" 
            rows={2} 
            onChange={(e) => setExplanation(e.target.value)} 
            placeholder="Entrez une explication"
          />
        </Form.Group>
      

      <Button onClick={(e) => handleRapportSpintoss(e)} variant="primary" type="submit" className="rapport-button">
        Soumettre
      </Button>
    </Form>
    </div>
  );
};

export default RapportsSpintoss;
